var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkMonitoringLanding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.33333C0 2.38782 2.38781 0 5.33333 0H22.6667C25.6122 0 28 2.38781 28 5.33333V22.6667C28 25.6122 25.6122 28 22.6667 28H5.33333C2.38782 28 0 25.6122 0 22.6667V5.33333Z",
    fill: "#F8E8E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8069_15838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2209 18.3833C16.5189 18.3833 18.3818 16.5204 18.3818 14.2223C18.3818 11.9243 16.5189 10.0614 14.2209 10.0614C11.9229 10.0614 10.0599 11.9243 10.0599 14.2223C10.0599 16.5204 11.9229 18.3833 14.2209 18.3833Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46008 8.4176L11.2756 11.258",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88655 8.66715C8.34065 8.66715 8.70878 8.29903 8.70878 7.84493C8.70878 7.39083 8.34065 7.02271 7.88655 7.02271C7.43245 7.02271 7.06433 7.39083 7.06433 7.84493C7.06433 8.29903 7.43245 8.66715 7.88655 8.66715Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2735 10.5609L10.9779 9.26527L11.825 8.41813L11.3018 7.8949",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7281 8.14396C11.1822 8.14396 11.5503 7.77583 11.5503 7.32173C11.5503 6.86763 11.1822 6.49951 10.7281 6.49951C10.274 6.49951 9.90588 6.86763 9.90588 7.32173C9.90588 7.77583 10.274 8.14396 10.7281 8.14396Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5008 12.2296L9.25501 10.9838L8.40788 11.8309L7.88464 11.3077",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31185 11.557C7.76595 11.557 8.13407 11.1889 8.13407 10.7348C8.13407 10.2807 7.76595 9.9126 7.31185 9.9126C6.85775 9.9126 6.48962 10.2807 6.48962 10.7348C6.48962 11.1889 6.85775 11.557 7.31185 11.557Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46008 8.4176L11.2756 11.258",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88655 8.66715C8.34065 8.66715 8.70878 8.29903 8.70878 7.84493C8.70878 7.39083 8.34065 7.02271 7.88655 7.02271C7.43245 7.02271 7.06433 7.39083 7.06433 7.84493C7.06433 8.29903 7.43245 8.66715 7.88655 8.66715Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2735 10.5609L10.9779 9.26527L11.825 8.41813L11.3018 7.8949",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7281 8.14396C11.1822 8.14396 11.5503 7.77583 11.5503 7.32173C11.5503 6.86763 11.1822 6.49951 10.7281 6.49951C10.274 6.49951 9.90588 6.86763 9.90588 7.32173C9.90588 7.77583 10.274 8.14396 10.7281 8.14396Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5008 12.2296L9.25501 10.9838L8.40788 11.8309L7.88464 11.3077",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31185 11.557C7.76595 11.557 8.13407 11.1889 8.13407 10.7348C8.13407 10.2807 7.76595 9.9126 7.31185 9.9126C6.85775 9.9126 6.48962 10.2807 6.48962 10.7348C6.48962 11.1889 6.85775 11.557 7.31185 11.557Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9739 20.027L17.1584 17.1866",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5466 21.4228C21.0007 21.4228 21.3688 21.0546 21.3688 20.6005C21.3688 20.1464 21.0007 19.7783 20.5466 19.7783C20.0925 19.7783 19.7244 20.1464 19.7244 20.6005C19.7244 21.0546 20.0925 21.4228 20.5466 21.4228Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1866 17.9088L17.4574 19.1795L16.6102 20.0267L17.1334 20.5499",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7059 21.9452C18.16 21.9452 18.5281 21.5771 18.5281 21.123C18.5281 20.6689 18.16 20.3008 17.7059 20.3008C17.2518 20.3008 16.8837 20.6689 16.8837 21.123C16.8837 21.5771 17.2518 21.9452 17.7059 21.9452Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9054 16.1893L19.1761 17.46L20.0232 16.6129L20.5465 17.1361",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.12 18.5313C21.5741 18.5313 21.9422 18.1632 21.9422 17.7091C21.9422 17.255 21.5741 16.8868 21.12 16.8868C20.6659 16.8868 20.2977 17.255 20.2977 17.7091C20.2977 18.1632 20.6659 18.5313 21.12 18.5313Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0253 8.46753L17.1849 11.283",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5983 8.71708C21.0524 8.71708 21.4206 8.34895 21.4206 7.89485C21.4206 7.44075 21.0524 7.07263 20.5983 7.07263C20.1442 7.07263 19.7761 7.44075 19.7761 7.89485C19.7761 8.34895 20.1442 8.71708 20.5983 8.71708Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8837 12.2794L19.1793 10.9838L20.0264 11.8309L20.5497 11.3077",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1234 11.557C21.5775 11.557 21.9456 11.1889 21.9456 10.7348C21.9456 10.2807 21.5775 9.9126 21.1234 9.9126C20.6693 9.9126 20.3011 10.2807 20.3011 10.7348C20.3011 11.1889 20.6693 11.557 21.1234 11.557Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2131 10.5111L17.4589 9.26527L16.6118 8.41813L17.135 7.8949",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7081 8.14396C18.1622 8.14396 18.5303 7.77583 18.5303 7.32173C18.5303 6.86763 18.1622 6.49951 17.7081 6.49951C17.254 6.49951 16.8859 6.86763 16.8859 7.32173C16.8859 7.77583 17.254 8.14396 17.7081 8.14396Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0253 8.46753L17.1849 11.283",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5983 8.71708C21.0524 8.71708 21.4206 8.34895 21.4206 7.89485C21.4206 7.44075 21.0524 7.07263 20.5983 7.07263C20.1442 7.07263 19.7761 7.44075 19.7761 7.89485C19.7761 8.34895 20.1442 8.71708 20.5983 8.71708Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8837 12.2794L19.1793 10.9838L20.0264 11.8309L20.5497 11.3077",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1234 11.557C21.5775 11.557 21.9456 11.1889 21.9456 10.7348C21.9456 10.2807 21.5775 9.9126 21.1234 9.9126C20.6693 9.9126 20.3011 10.2807 20.3011 10.7348C20.3011 11.1889 20.6693 11.557 21.1234 11.557Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2131 10.5111L17.4589 9.26527L16.6118 8.41813L17.135 7.8949",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7081 8.14396C18.1622 8.14396 18.5303 7.77583 18.5303 7.32173C18.5303 6.86763 18.1622 6.49951 17.7081 6.49951C17.254 6.49951 16.8859 6.86763 16.8859 7.32173C16.8859 7.77583 17.254 8.14396 17.7081 8.14396Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4115 19.9775L11.2519 17.162",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8387 21.3728C8.2928 21.3728 8.66092 21.0047 8.66092 20.5506C8.66092 20.0965 8.2928 19.7284 7.8387 19.7284C7.3846 19.7284 7.01648 20.0965 7.01648 20.5506C7.01648 21.0047 7.3846 21.3728 7.8387 21.3728Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5274 16.1893L9.25672 17.46L8.40958 16.6129L7.88635 17.1361",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31356 18.5313C7.76766 18.5313 8.13578 18.1632 8.13578 17.7091C8.13578 17.255 7.76766 16.8868 7.31356 16.8868C6.85945 16.8868 6.49133 17.255 6.49133 17.7091C6.49133 18.1632 6.85945 18.5313 7.31356 18.5313Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2503 17.9088L10.9796 19.1795L11.8268 20.0267L11.3035 20.5499",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7298 21.9452C11.1839 21.9452 11.552 21.5771 11.552 21.123C11.552 20.6689 11.1839 20.3008 10.7298 20.3008C10.2757 20.3008 9.90759 20.6689 9.90759 21.123C9.90759 21.5771 10.2757 21.9452 10.7298 21.9452Z",
    stroke: "black",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2204 15.4187C14.8809 15.4187 15.4163 14.8832 15.4163 14.2227C15.4163 13.5622 14.8809 13.0267 14.2204 13.0267C13.5599 13.0267 13.0244 13.5622 13.0244 14.2227C13.0244 14.8832 13.5599 15.4187 14.2204 15.4187Z",
    stroke: "#BD1D23",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9863 14.8453C16.9115 15.1692 16.7869 15.4682 16.6125 15.7423C16.3135 15.6177 16.0146 15.6426 15.8401 15.8171C15.6657 15.9915 15.6408 16.2905 15.7405 16.5894C15.4664 16.7639 15.1674 16.8884 14.8435 16.9632C14.7189 16.6642 14.4947 16.4649 14.2206 16.4649C13.9715 16.4649 13.7472 16.6642 13.5977 16.9632C13.2738 16.8884 12.9748 16.7639 12.7007 16.5894C12.8253 16.2905 12.8004 15.9915 12.6011 15.8171C12.4267 15.6426 12.1277 15.6177 11.8287 15.7423C11.6543 15.4682 11.5297 15.1692 11.455 14.8453C11.7539 14.7208 11.9533 14.4965 11.9533 14.2224C11.9533 13.9733 11.7539 13.749 11.455 13.5995C11.5297 13.2756 11.6543 12.9767 11.8287 12.7026C12.1277 12.8272 12.4267 12.8022 12.6011 12.6029C12.7755 12.4285 12.8004 12.1295 12.7007 11.8305C12.9748 11.6561 13.2738 11.5315 13.5977 11.4568C13.7223 11.7558 13.9465 11.9551 14.2206 11.9551C14.4698 11.9551 14.694 11.7558 14.8435 11.4568C15.1674 11.5315 15.4664 11.6561 15.7405 11.8305C15.6159 12.1295 15.6408 12.4285 15.8401 12.6029C16.0146 12.7773 16.3135 12.8022 16.6125 12.7026C16.7869 12.9767 16.9115 13.2756 16.9863 13.5995C16.6873 13.7241 16.488 13.9484 16.488 14.2224C16.488 14.4716 16.6873 14.6958 16.9863 14.8453Z",
    stroke: "#BD1D23",
    strokeWidth: 0.498316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8069_15838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkMonitoringLanding);
export default __webpack_public_path__ + "static/media/networkMonitoringLanding.d44aa013c8061f7ee8bb6053eda4ed4c.svg";
export { ForwardRef as ReactComponent };